import { type MatSort, type Sort } from '@angular/material/sort';
import { sortUtils } from '@core';

import { type IncidentsV2GridRow } from '../incidents-v2-table/incidents-v2-grid';

/* naturalSorting sorts in place */
export function sortIncidentRows(rows: IncidentsV2GridRow[], sort: Sort) {
  if (!sort.active || !sort.direction) {
    return rows;
  }

  return sortUtils.naturalSorting([...rows], sort as MatSort);
}
